import React from 'react';
import { Box, Typography } from '@mui/material';
import Modal from '../../../ui/layout/Modal';
import Attachments from '../../attachments/Attachments';

const ENTITY_TYPE = 'TestStep';

const TestStepAttachments = ({
  show,
  handleClose,
  testStepId,
  selectedScript,
  fetchScripts,
}) => (
  <Modal
    open={show}
    handleClose={handleClose}
    width="lg"
    modalTitle="Test Step Attachments"
  >
    <Box>
      <Typography
        variant="overline"
        sx={{ color: 'text.secondary', letterSpacing: '0.06em', mb: 1.5, display: 'block' }}
      >
        Step {selectedScript?.sNo}
      </Typography>
      <Attachments
        entityType={ENTITY_TYPE}
        entityId={testStepId}
        showHeader={false}
        refreshData={fetchScripts}
        hideTitle={true}
      />
    </Box>
  </Modal>
);

export default TestStepAttachments;